<template>
  <div class="ui container">
    <div><h4>PAY WITH</h4></div>
    <div class="ui grid">
      <div class="eight wide column gcash-balance-label">
        GCash
      </div>
      <div class="eight wide column" style="text-align: center;">
        <div>PHP 1,234.50</div>
        <div>Available Balance</div>
      </div>
    </div>
    <div style="margin-top:15px;"><h4>YOU ARE ABOUT TO PAY</h4></div>
    <div class="ui grid">
      <div class="eight wide column gcash-balance-label">
        Amount Due
      </div>
      <div class="eight wide column" style="text-align: right;">
        <div>PHP {{ this.chosenLoad }}</div>
      </div>
    </div>
    <div class="ui grid">
      <div class="eight wide column gcash-balance-label">
        Discount
      </div>
      <div class="eight wide column" style="text-align: right;">
        <select class="ui compact dropdown" v-model="discountVoucher">
          <option value="">Select Voucher</option>
          <option value="No Discount Voucher">Do Not Use Voucher</option>
          <option value="PHP 10.00 Voucher">PHP 10.00 Voucher</option>
          <option value="PHP 10.00 Voucher">PHP 20.00 Voucher</option>
        </select>
      </div>
    </div>
    <div class="ui clearing divider"></div>
    <div class="ui grid">
      <div class="eight wide column gcash-balance-label">
        Total Amount
      </div>
      <div class="eight wide column" style="text-align: right;">
        <div>PHP {{ this.chosenLoad }}</div>
      </div>
    </div>
    <div class="button-div">
      <button class="ui fluid primary button" @click="pay">
        PAY PHP {{ this.chosenLoad }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      phoneNumber: '',
      chosenLoad: '',
      discountVoucher: ''
    }
  },
  mounted () {
    this.phoneNumber = this.$route.params.phone_number
    this.chosenLoad = this.$route.params.chosen_load

    // eslint-disable-next-line
    $('.ui.dropdown').dropdown()
  },
  methods: {
    pay () {
      this.$router.push({
        name: 'OTP',
        params: {
          phone_number: this.phoneNumber,
          chosen_load: this.chosenLoad,
          discount_voucher: this.discountVoucher
        }
      })
    }
  }
}
</script>

<style scoped>
.gcash-balance-label {
  display: flex !important;
  align-items: center !important;
}
.button-div {
  margin-top: 20px;
}
button {
  border-radius: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BuyLoad/Cashier.vue